import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { Category } from 'shared-types';

export async function getSpaCategories(
  propertyId: number,
  entity: 'packages' | 'treatments' = 'packages',
  language?: string
) {
  const { data } = await request.get(
    `${propertyId}/categories${language ? `/${language}` : ''}`,
    { params: { perPage: 0 } },
    {
      isPayloadCaseConverterDisabled: true,
    }
  );
  const visible = (data?.data || []).filter((cat) => !cat.isPrivate);
  return entity === 'packages'
    ? (visible.filter((cat) => cat.hasSpaPackages) as Category[])
    : (visible.filter((cat) => cat.hasTreatments) as Category[]);
}

export const getSpaCategoriesPrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  entity: 'packages' | 'treatments' = 'packages',
  language?: string
) =>
  queryClient.prefetchQuery(getSpaCategoriesKey(propertyId, entity, language), () =>
    getSpaCategories(propertyId, entity, language)
  );

export const useGetSpaCategories = (
  propertyId: number,
  entity: 'packages' | 'treatments' = 'packages',
  language?: string
) => {
  return useQuery({
    queryKey: getSpaCategoriesKey(propertyId, entity, language),
    queryFn: () => getSpaCategories(propertyId, entity, language),
  });
};

export const getSpaCategoriesKey = (
  propertyId: number,
  entity: 'packages' | 'treatments',
  language?: string
) => ['spaCategories', propertyId, entity, language];
